import React, { useState } from 'react'
import { Card, Collapse } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

function TemporaryAccessPassSuccessItem({ displayName, children, hasDetails = false }) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Card style={{ border: 'none', margin: 0 }}>
      <Card.Header
        onClick={() => setIsOpen(!isOpen)}
        onKeyUp={(e) => (e.key === 'Enter' || e.key === ' ') && setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <i className="icon-xl align-text-bottom font-color-engage fas fa-circle-check me-2" />
          <span style={{ flexGrow: 1 }}>{displayName}</span>
          {hasDetails && (
            <button type="button" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
              {isOpen ? (
                <FormattedMessage id="ENGAGE.TEMPORARY_ACCESS_PASS_HIDE_DETAILS" />
              ) : (
                <FormattedMessage id="ENGAGE.TEMPORARY_ACCESS_PASS_SHOW_DETAILS" />
              )}
            </button>
          )}
        </div>
      </Card.Header>
      <Collapse in={isOpen}>
        <Card.Body className="mt-2" style={{ padding: 0, paddingLeft: '1rem' }}>
          {children}
        </Card.Body>
      </Collapse>
    </Card>
  )
}
TemporaryAccessPassSuccessItem.propTypes = {
  displayName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  hasDetails: PropTypes.bool,
}
export default TemporaryAccessPassSuccessItem
